import React, { useState, useEffect, useRef } from 'react';
import './Element.css';
// import { EditText, EditTextarea } from "react-edit-text";
import "react-edit-text/dist/index.css";
import { useSelector, useDispatch } from "react-redux";
import { updateGoToSlide, updateElementInputFocus, updateIsVoiceInput } from '../../redux/slices/userActivity';
import { useLocation, } from "react-router-dom";
import { showDuonutresponse, saveQuizAnsAsync, saveQuizResponse, showduonutData } from '../../redux/slices/DuonutReducer';
import axios from "axios";
import { domain } from "../../services/constants";
import { getOpenEndedQuestionAsync } from '../../redux/slices/AiDuonutNewReducer';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { Tooltip as ReactTooltip } from "react-tooltip";
import 'react-tooltip/dist/react-tooltip.css';

var aiCount = 0;
var aiConversation = [];
var audioFile = null;
const CheckboxGroup = ({
    id,
    elementAttr: {
        text, color, fontFamily, fontSize, fontWeight, options, fontStyle, textDecoration, textTransform, textAlign,
        lineHeight, letterSpacing, backgroundColor, border, margin, padding, borderRadius, other, maxLength, gap,
        labelFontSize, labelFontWeight, labelColor, required, fieldPosition,
        openEnded, openEndedObjective, openEndedFeedbackDesired,
    },
    elementHoverAttr,
    // conditions,
    language,
    slideId,
}) => {
    const dispatch = useDispatch();
    const { selectedSlide, queSpeechPlaying, isVoiceInput } = useSelector((state) => state.userActivity);
    const location = useLocation();
    const save_ans_response = useSelector(showDuonutresponse);
    const { viewer_display_id, viewer_nick_name, viewer_url_params } = useSelector((state) => state.duonut);
    const [selectedAnswer, setselectedAnswer] = useState([]);
    const [otherText, setOtherText] = useState('');
    const { viewType } = useSelector((state) => state.duonutSettings);
    const { width } = useWindowDimensions();
    const [hover, setHover] = useState(-1);
    const [inputText, setInputText] = useState("");
    const [optionsText, setoptionsText] = useState([]);
    const [loading, setloading] = useState(false);
    const [textField, setTextField] = useState('');
    const duonutDataMain = useSelector(showduonutData);
    const duonutData = duonutDataMain[0];
    // const [copySelectedData, setCopySelectedData] = useState([]);
    const checkboxGroupRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const [audioUrl, setAudioUrl] = useState(null);
    const [typedText, setTypedText] = useState("");
    const [isListening, setIsListening] = useState(false)
    const [error, setError] = useState("")
    const [isTypingDone, setIsTypingDone] = useState(true);
    const recognitionRef = useRef(null)
    const mediaRecorderRef = useRef(null);
    const recordedChunksRef = useRef([]);

    useEffect(() => {
        if (!inputText || !audioUrl) return;

        // Safely split words including spaces
        const words = inputText.match(/\S+\s*/g)?.filter(Boolean) || [];

        if (words.length === 0) return;

        let index = 0;
        let currentText = "";
        setIsTypingDone(false); // start typing → disable input

        const interval = setInterval(() => {
            if (index < words.length) {
                currentText += words[index]; // safe accumulation
                setTypedText(currentText);
                index++;
            } else {
                clearInterval(interval);
                setIsTypingDone(true); // ✅ Typing complete → enable input
            }
        }, 300);

        return () => clearInterval(interval);
    }, [inputText, audioUrl]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            { threshold: 0.5 } // 50% of the div must be visible
        );

        if (checkboxGroupRef.current) {
            observer.observe(checkboxGroupRef.current);
        }

        return () => {
            if (checkboxGroupRef.current) {
                observer.unobserve(checkboxGroupRef.current);
            }
        };
    }, [inputText]);

    useEffect(() => {
        setTextField("");
        if (isVisible && inputText && queSpeechPlaying && duonutData?.setting?.question_speech && location.pathname.includes("/duonut/") && slideId === `slide-${selectedSlide}`) {
            fetchAudio(inputText);
        } else {
            setAudioUrl(null);
        }
    }, [isVisible, inputText, queSpeechPlaying]);


    useEffect(() => {
        setselectedAnswer([]);
        aiCount = 0;
        aiConversation = [];

        if (location.pathname.includes("/duonut/") && slideId === `slide-${selectedSlide}` && language !== "en") {
            fetchText(text);
            fetchOptionsText(options);
        } else {
            setInputText(text);
            setoptionsText(options);
        }
    }, [text, options]);

    const fetchOptionsText = async (texts) => {
        const translatedTexts = []; // Initialize an array to hold translated texts
        const delimiter = "[[SEP]]"; // Delimiter to separate texts
        const delimiterRegex = /\[\[SEP\]\]|\[SEP\]/;

        // Combine all texts into a single string separated by semicolons
        const textToTranslate = texts.join(delimiter);

        // Translate the combined text
        const translated = await translateText(textToTranslate, language);

        // Split the translated text back into individual parts using the semicolon delimiter
        const translatedArray = translated.split(delimiterRegex);

        // Push the translated texts into the array
        translatedTexts.push(...translatedArray); // Spread the array into the translatedTexts

        setoptionsText(translatedTexts); // Update the state with the translated texts
    };
    const fetchText = async (texts) => {
        const t_text = await translateText(texts, language);
        setInputText(t_text);
    };
    const translateText = async (texts, targetLanguage) => {
        try {
            const response = await axios({
                method: "POST",
                url: `${domain}/duonut/language_translator`,
                headers: {
                    "Content-Type": "application/json",
                },
                data: {
                    source: "en",
                    target: targetLanguage,
                    query: texts,
                },
            });

            if (response.status === 200) {
                // console.log("Translation:", response);
                return response?.data.translation; // return the translated text
            } else {
                // Handle unsuccessful status codes
                return "Error: Translation failed. Please try again.";
            }
        } catch (error) {
            console.error('Error in translation API:', error);
            return "Error translating text. Please try again."; // Handle API errors gracefully
        }
    };

    const fetchAudio = async (texts) => {
        const response = await fetch(`${domain}/duonut/get_speech`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ question_text: texts }),
        });

        const data = await response.json();
        if (data.audio_base64) {
            const audioSrc = `data:audio/mp3;base64,${data.audio_base64}`;
            setAudioUrl(audioSrc);
        }
    };

    const startListening = async () => {
        setError("");

        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            recordedChunksRef.current = [];

            const mediaRecorder = new MediaRecorder(stream);
            mediaRecorderRef.current = mediaRecorder;

            mediaRecorder.ondataavailable = (event) => {
                if (event.data && event.data.size > 0) {
                    recordedChunksRef.current.push(event.data);
                }
            };

            mediaRecorder.start();
            console.log("Recording started!");

            // ---- SpeechRecognition part remains same ---- //
            const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
            if (!SpeechRecognition) {
                setError("Speech recognition is not supported in your browser. Try Chrome or Edge.");
                return;
            }

            recognitionRef.current = new SpeechRecognition();
            recognitionRef.current.continuous = true;
            recognitionRef.current.interimResults = true;
            recognitionRef.current.lang = "en-US";

            recognitionRef.current.onresult = (event) => {
                let interimTranscript = "";
                let finalTranscript = "";

                for (let i = event.resultIndex; i < event.results.length; i++) {
                    const transcript = event.results[i][0].transcript;
                    if (event.results[i].isFinal) {
                        finalTranscript += transcript + " ";
                    } else {
                        interimTranscript += transcript;
                    }
                }

                console.log(finalTranscript || interimTranscript);
                setTextField(finalTranscript || interimTranscript);
            };

            recognitionRef.current.onerror = (event) => {
                console.error("Speech recognition error", event.error);
                setError(`Error: ${event.error}. Please try again.`);
                if (recognitionRef.current) {
                    recognitionRef.current.stop();
                    recognitionRef.current = null;
                }
                setIsListening(false);
            };

            recognitionRef.current.start();
            setIsListening(true);

        } catch (err) {
            console.error("Speech recognition error:", err);
            setError("Failed to start speech recognition. Please check your browser permissions.");
        }
    };

    const stopListening = () => {
        if (recognitionRef.current) {
            recognitionRef.current.stop()
            recognitionRef.current = null;
        }
        if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop();
            mediaRecorderRef.current.stream.getTracks().forEach(track => track.stop());
            mediaRecorderRef.current = null;
        }
        setIsListening(false);

        setTimeout(() => {
            if (recordedChunksRef.current.length === 0) {
                console.error("No audio recorded.");
                setError("No audio recorded. Please try speaking louder or allow microphone access.");
                return;
            }

            const audioBlob = new Blob(recordedChunksRef.current, { type: 'audio/webm' });
            const file = new File([audioBlob], "audio_recording.webm", { type: "audio/webm" });

            // console.log(file);
            audioFile = file;

            submitResponse(textField);
        }, 100);
    }

    const updatingSelectedAnswer = (item) => {
        let selectedAnswerCopy;

        if (!selectedAnswer.includes(item)) {
            selectedAnswerCopy = [...selectedAnswer, item]; // New array with added item
        } else {
            selectedAnswerCopy = selectedAnswer.filter(ans => ans !== item); // Create new array excluding the item
        }

        setselectedAnswer(selectedAnswerCopy);
        // console.log(selectedAnswerCopy);
    }
    const submitResponse = (item) => {
        setIsVisible(false);
        setTypedText("");

        // console.log("submit", selectedAnswer);
        var ans_other = selectedAnswer.map((selectedans, i) => {
            // console.log(otherText);
            if (selectedans === "other") {
                return (selectedans + " - " + otherText);
            } else {
                return (selectedans);
            }
        });
        // console.log(ans_other);
        var ans = "";
        ans_other.map((selectedans, i) => {
            if (ans) {
                ans = ans + "; " + selectedans;
            }
            else {
                ans = selectedans;
            }
            return null;
        })
        setselectedAnswer(ans_other);
        if (location.pathname.includes("/duonut/") && !openEnded) {

            var save_ans = {
                display_id: viewer_display_id,
                watch_id: save_ans_response[0] ? save_ans_response[0].watch_id : "",
                result: 0,
                question: text ? text : "",
                answered_text: ans,
                // end: lastQue ? "1" : "0",
                nickname: viewer_nick_name,
                step: selectedSlide + 1,
                type: "CheckboxGroup",
                // country: location[0] ? location[0].address?.country : "",
                // city: location[0] ? location[0].address?.state_district : "",
                // location: location[0] ? location[0].display_name : "",
                url_params: viewer_url_params,
            }
            // console.log(save_ans);
            const formData = new FormData();
            formData.append("analytic_file", audioFile);
            Object.keys(save_ans).forEach(key => {
                const value = typeof save_ans[key] === "object" ? JSON.stringify(save_ans[key]) : save_ans[key];
                formData.append(key, value);
            });

            dispatch(saveQuizAnsAsync(formData));

            var save_response = {
                id: id,
                type: "CheckboxGroup",
                step: selectedSlide + 1,
                question: text ? text : "",
                answered_text: ans,
            }
            dispatch(saveQuizResponse(save_response));
            var nextPage = selectedSlide + 1;

            setTimeout(() => {
                dispatch(updateGoToSlide(nextPage));
            }, 1000);
        }
        else if (location.pathname.includes("/duonut/") && openEnded) {
            // console.log("question", inputText, textField);
            // Update selectedAnswer state

            var userIsPro = false;
            if (duonutData?.created_by.pro_user) {
                userIsPro = true;
            } else if (duonutData?.created_by.expire_date) {
                const currentDate = new Date();
                const dateToCompare = new Date(duonutData?.created_by.expire_date);
                const comparisonResult = currentDate < dateToCompare;
                if (comparisonResult) {
                    userIsPro = true;
                } else {
                    userIsPro = false;
                }
            }
            if ((!userIsPro && aiCount < parseInt(duonutData?.setting?.open_ended_conversation_limit)) || (userIsPro && aiCount < parseInt(duonutData?.setting?.open_ended_conversation_limit))) {

                setloading(true);

                aiConversation = [...aiConversation,
                { question: inputText, answer: textField },
                ];

                var get_ans = {
                    question: inputText,
                    answer: aiCount === 0 ? ans : item,
                    objective: openEndedObjective,
                    feedbackDesired: openEndedFeedbackDesired,
                    aiConversation: aiConversation,
                    option_type: 1,
                }

                dispatch(getOpenEndedQuestionAsync(get_ans)).then((res) => {
                    // console.log(res);
                    if (res?.question) {
                        // console.log(res?.question);
                        setInputText(res?.question);
                        if (document.getElementById(`qainput-${selectedSlide + 1}-ai${aiCount}`)) {
                            document.getElementById(`qainput-${selectedSlide + 1}-ai${aiCount}`).value = "";
                        }
                        setloading(false);

                        var save_ans = {
                            display_id: viewer_display_id,
                            watch_id: save_ans_response[0] ? save_ans_response[0].watch_id : "",
                            result: 1,
                            question: inputText ? inputText : "",
                            answered_text: aiCount === 0 ? ans : item,
                            // end: lastQue ? "1" : "0",
                            nickname: viewer_nick_name,
                            step: aiCount === 0 ? selectedSlide + 1 : `${selectedSlide + 1}-ai${aiCount}`,
                            type: aiCount === 0 ? "CheckboxGroup" : "QuestionAnswer",
                            // country: location[0] ? location[0].address?.country : "",
                            // city: location[0] ? location[0].address?.state_district : "",
                            // location: location[0] ? location[0].display_name : "",
                            url_params: viewer_url_params,
                        }
                        // console.log(save_ans);
                        const formData = new FormData();
                        formData.append("analytic_file", audioFile);
                        Object.keys(save_ans).forEach(key => {
                            const value = typeof save_ans[key] === "object" ? JSON.stringify(save_ans[key]) : save_ans[key];
                            formData.append(key, value);
                        });

                        dispatch(saveQuizAnsAsync(formData));

                        var save_response = {
                            type: "QuestionAnswer",
                            step: aiCount === 0 ? selectedSlide + 1 : `${selectedSlide + 1}-ai${aiCount}`,
                            question: inputText ? inputText : "",
                            answered_text: aiCount === 0 ? ans : item,
                        }
                        dispatch(saveQuizResponse(save_response));

                        aiCount++;

                    }
                }).catch((e) => {
                    console.log(e.message, e);
                });
            } else {
                var save_ans = {
                    display_id: viewer_display_id,
                    watch_id: save_ans_response[0] ? save_ans_response[0].watch_id : "",
                    result: 1,
                    question: inputText ? inputText : "",
                    answered_text: aiCount === 0 ? ans : item,
                    // end: lastQue ? "1" : "0",
                    nickname: viewer_nick_name,
                    step: aiCount === 0 ? selectedSlide + 1 : `${selectedSlide + 1}-ai${aiCount}`,
                    type: aiCount === 0 ? "CheckboxGroup" : "QuestionAnswer",
                    // country: location[0] ? location[0].address?.country : "",
                    // city: location[0] ? location[0].address?.state_district : "",
                    // location: location[0] ? location[0].display_name : "",
                    url_params: viewer_url_params,
                }
                // console.log(save_ans);
                const formData = new FormData();
                formData.append("analytic_file", audioFile);
                Object.keys(save_ans).forEach(key => {
                    const value = typeof save_ans[key] === "object" ? JSON.stringify(save_ans[key]) : save_ans[key];
                    formData.append(key, value);
                });

                dispatch(saveQuizAnsAsync(formData));

                var save_response = {
                    type: aiCount === 0 ? "CheckboxGroup" : "QuestionAnswer",
                    step: aiCount === 0 ? selectedSlide + 1 : `${selectedSlide + 1}-ai${aiCount}`,
                    question: inputText ? inputText : "",
                    answered_text: item,
                }
                dispatch(saveQuizResponse(save_response));

                var nextPage = selectedSlide + 1;

                setTimeout(() => {
                    dispatch(updateGoToSlide(nextPage));
                }, 1000);
            }

        }
    }

    const handleOtherInputChange = (e) => {
        if (location.pathname.includes("/duonut/")) {
            setOtherText(e.target.value);
        }
    }

    const handleInputFocus = () => {
        dispatch(updateElementInputFocus(true));
    }
    const handleInputBlur = () => {
        dispatch(updateElementInputFocus(false));
    }
    const handleQuestionAnswerInputChange = (e) => {
        // console.log(e)
        if (location.pathname.includes("/duonut/")) {
            if (e.keyCode === 13) {
                setTimeout(() => {
                    var text_ans = e.target.value;
                    submitResponse(text_ans);
                }, 0); // Let the event loop update React state first
            }
        }
    }

    return (
        <div ref={checkboxGroupRef} >
            {(audioUrl || !duonutData?.setting?.question_speech || !queSpeechPlaying) ?
                <>
                    {audioUrl && (
                        <audio autoPlay style={{ display: "none" }}>
                            <source src={audioUrl} type="audio/mp3" />
                            Your browser does not support the audio element.
                        </audio>
                    )}
                    {aiCount === 0 &&
                        <div style={{
                            display: "flex", flexDirection: "column", gap: viewType === 3 || width < 800 ? "80px" : gap
                        }}>
                            <div style={{
                                width: "100%", paddingBottom: '10px',
                                color: labelColor, fontFamily, fontSize: labelFontSize, fontWeight: labelFontWeight, fontStyle, textDecoration, textTransform,
                                textAlign, lineHeight, letterSpacing,
                            }}>{(duonutData?.setting?.question_speech && queSpeechPlaying && location.pathname.includes("/duonut/")) ? typedText : inputText}</div>
                            <div style={{
                                display: "flex", justifyContent:
                                    fieldPosition === "row"
                                        ? "space-around"
                                        : textAlign === "justify"
                                            ? "flex-start"
                                            : textAlign,
                                // alignItems: 'center', 
                                alignItems: 'flex-start',
                                flexDirection: (viewType === 3 || width < 800) ? "column" : fieldPosition
                            }}>
                                {isTypingDone && <>
                                    {options.map((item, i) => {
                                        return <label style={{
                                            display: "flex", justifyContent: "flex-start", alignItems: "center", lineHeight, width: fieldPosition === "column" ? "100%" : "100%",
                                        }} key={i} htmlFor={`checkbox_option${slideId}_${id}_${i}`}
                                            onMouseEnter={() => setHover(i)}
                                            onMouseLeave={() => setHover(-1)}>
                                            <input type="checkbox" id={`checkbox_option${slideId}_${id}_${i}`} name={`checkbox_option${slideId}_${id}_${i}`}
                                                style={{
                                                    width: fontSize, height: fontSize, minWidth: fontSize, minHeight: fontSize, margin: "2px",
                                                    // accentColor: `${color}` 
                                                }}
                                                checked={selectedAnswer.includes(item) ? true : false}
                                                disabled={(maxLength !== 0 && maxLength === selectedAnswer.length && !selectedAnswer.includes(item)) ? true : false}
                                                onChange={() => { !(maxLength !== 0 && maxLength === selectedAnswer.length && !selectedAnswer.includes(item)) && updatingSelectedAnswer(item) }}
                                            />
                                            <div style={{
                                                backgroundColor: hover === i ? elementHoverAttr?.backgroundColor : backgroundColor,
                                                border: hover === i ? elementHoverAttr?.border : border ? border : "0",
                                                color: hover === i ? elementHoverAttr?.color : color,
                                                borderRadius, fontFamily, fontSize, fontWeight, fontStyle, textDecoration,
                                                textTransform, textAlign, letterSpacing, padding, margin,
                                                cursor: (location.pathname).includes("/duonut/") ? "pointer" : "default",
                                                width: "100%", height: "100%"
                                            }}

                                            // onClick={() => {
                                            //     !(maxLength !== 0 && maxLength === selectedAnswer.length && !selectedAnswer.includes(item))
                                            //         && updatingSelectedAnswer(item)

                                            // }}
                                            >
                                                <div style={{}}>{optionsText[i]}</div>
                                            </div>
                                        </label>
                                    })}
                                    {other && <div style={{
                                        display: "flex", justifyContent: "flex-start", alignItems: "center", lineHeight, width: fieldPosition === "column" ? "100%" : "100%"
                                    }}>
                                        <input type="checkbox" id={`checkbox_option_other${slideId}_${id}`} name={`checkbox_option_other${slideId}_${id}`}
                                            style={{
                                                width: fontSize, height: fontSize, minWidth: fontSize, minHeight: fontSize, margin: "2px",
                                                // accentColor: `${color}`
                                            }}
                                            checked={selectedAnswer.includes("other") ? true : false}
                                            disabled={(maxLength !== 0 && maxLength === selectedAnswer.length && !selectedAnswer.includes("other")) ? true : false}
                                            onChange={() => {
                                                !(maxLength !== 0 && maxLength === selectedAnswer.length && !selectedAnswer.includes("other"))
                                                    && updatingSelectedAnswer("other")
                                            }} />
                                        <div style={{
                                            backgroundColor: hover === options.length ? elementHoverAttr?.backgroundColor : backgroundColor,
                                            border: hover === options.length ? elementHoverAttr?.border : border ? border : "0",
                                            color: hover === options.length ? elementHoverAttr?.color : color,
                                            borderRadius, fontFamily, fontSize, fontWeight, fontStyle, textDecoration,
                                            textTransform, textAlign, letterSpacing, padding, margin,
                                            cursor: (location.pathname).includes("/duonut/") ? "pointer" : "default",
                                            width: "100%", height: "100%"
                                        }}
                                            onMouseEnter={() => setHover(options.length)}
                                            onMouseLeave={() => setHover(-1)}
                                            onClick={() => { !(maxLength !== 0 && maxLength === selectedAnswer.length && !selectedAnswer.includes("other")) && updatingSelectedAnswer("other") }}>
                                            <div style={{}}>{language === "hi" ? "अन्य" :
                                                language === "es" ? "Otra" :
                                                    language === "ja" ? "他の" :
                                                        language === "ar" ? "آخر" :
                                                            language === "fr" ? "Autre" :
                                                                language === "nl" ? "Ander" :
                                                                    language === "pt" ? "Outra" : "Other"}</div>
                                        </div>
                                        {(location.pathname.includes("/duonut/") && selectedAnswer.includes("other")) &&
                                            <>
                                                <input type='text' style={{
                                                    minWidth: "2rem", margin: "0px 6px", padding: "10px", width: "100%",
                                                    color, fontFamily, fontSize: fontSize, fontWeight, fontStyle, textDecoration, textTransform,
                                                    textAlign, lineHeight, letterSpacing,
                                                    backgroundColor, borderBottom: "1px solid gray", borderRadius,
                                                }}
                                                    onChange={(e) => handleOtherInputChange(e)}
                                                    readOnly={(location.pathname.includes("/duonut/") && selectedAnswer.includes("other")) ? false : true}
                                                />
                                                {/* <button onClick={() => { submitTextResponse("other"); }}
                                        style={{ backgroundColor: "#4299e1", color: "white", borderRadius: "6px", padding: '1rem', cursor: "pointer" }}>
                                        <i className="fa fa-arrow-right" aria-hidden="true"></i></button> */}
                                            </>
                                        }
                                    </div>}
                                </>}
                            </div>

                            {/* Submit Button */}
                            {isTypingDone && <div style={{ display: "flex", justifyContent: textAlign === "justify" ? "flex-start" : textAlign }}>
                                <button onClick={() => submitResponse(selectedAnswer)}
                                    style={{ backgroundColor: "#4299e1", color: "white", borderRadius: "6px", padding: '1rem', cursor: "pointer", fontSize: "14px", width: "150px" }}>
                                    Submit
                                </button>
                            </div>}
                        </div>
                    }
                    {openEnded && aiCount > 0 && <div style={{
                        display: "flex", justifyContent: 'space-between', flexDirection: "column", height: width > 800 ? "200px" : "400px",
                        //  width: "400px" 
                    }}>
                        <div
                            style={{
                                backgroundColor: "transparent",
                                border: "0",
                                outline: "none",
                                // display: "flex",
                                // alignItems: "center",
                                width: "100%",
                                color: labelColor, fontFamily, fontSize: fontSize, fontWeight, fontStyle, textDecoration, textTransform,
                                textAlign, lineHeight, letterSpacing
                            }}
                        > {(duonutData?.setting?.question_speech && queSpeechPlaying && location.pathname.includes("/duonut/")) ? typedText : inputText}</div>

                        <div>
                            {isVoiceInput && (location.pathname).includes("/duonut/") ? <><div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                {!isListening ? (
                                    <button
                                        onClick={() => startListening()}
                                        data-tooltip-content="Press to record your answer"
                                        data-tooltip-id="record_audio_hover"
                                        disabled={!isTypingDone} // 👈 disabled while typing
                                        style={{ fontSize: "1.2rem", width: "60px", height: "60px", borderRadius: "10rem", cursor: "pointer", backgroundColor: "white", border: "1px solid #4299e1", color: "#4299e1" }}
                                    >
                                        <i className="fa fa-microphone"></i>
                                    </button>
                                ) : (
                                    <button
                                        onClick={() => stopListening()}
                                        style={{ fontSize: "1.2rem", width: "60px", height: "60px", borderRadius: "10rem", cursor: "pointer", backgroundColor: "#4299e1", color: "white" }}
                                    >
                                        <i className="fa fa-microphone"></i>
                                    </button>
                                )}

                                {!isListening && <button
                                    data-tooltip-content="Answer using the keyboard"
                                    data-tooltip-id="record_audio_hover"
                                    disabled={!isTypingDone}
                                    onClick={() => dispatch(updateIsVoiceInput(false))}
                                    style={{ fontSize: "2rem", width: "4rem", height: "3.2rem", marginLeft: "1rem", borderRadius: "1rem", cursor: "pointer", backgroundColor: "white", color: "black" }}
                                >
                                    <i className="fa fa-keyboard-o"></i>
                                </button>}
                            </div>

                                {isListening && (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <span style={{ fontSize: "12px", padding: "5px", backgroundColor: "#4299e1", color: "white", borderRadius: "6px", margin: "2px" }}>Recording...</span>
                                    </div>
                                )}

                                {error && <div style={{ color: "red", display: "flex", justifyContent: "center" }}>{error}</div>}
                            </>
                                : <div style={{ display: "flex", alignItems: viewType === 3 || width < 800 ? "center" : "unset", flexDirection: viewType === 3 || width < 800 ? "column" : "unset" }}>
                                    <input type='text' key={`qainput-${selectedSlide + 1}-ai${aiCount}`}
                                        id={`qainput-${selectedSlide + 1}-ai${aiCount}`}
                                        style={{
                                            width: "100%", minHeight: "40px",
                                            color, fontFamily, fontSize: fontSize, fontStyle, textDecoration, textTransform,
                                            textAlign: "left", lineHeight, letterSpacing, padding: "4px 10px", boxSizing: "border-box",
                                            backgroundColor, border: '1px solid gray', margin: "0px 5px", borderRadius
                                        }}
                                        disabled={!isTypingDone} // 👈 disabled while typing
                                        onChange={(e) => setTextField(e.target.value)}
                                        onKeyUp={(e) => handleQuestionAnswerInputChange(e)}
                                        readOnly={location.pathname.includes("/duonut/") ? false : true}
                                        required={required}
                                        placeholder={"Type your answer here.."}
                                    />
                                    {textField ? <button id="AiSubmitBtn" onClick={() => submitResponse(textField)}
                                        style={{
                                            backgroundColor: "#4299e1", color: "white", borderRadius: "6px", padding: '1rem',
                                            cursor: "pointer", margin: viewType === 3 || width < 800 ? "1rem 0px" : "0px"
                                        }}>
                                        {loading ? <img alt="loader" src={require(`../../assets/Images/loader.gif`)} style={{ margin: "auto", height: "1rem" }} />
                                            : viewType === 3 || width < 800 ? <span style={{ fontSize: "1rem" }}> Next</span> : <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" aria-hidden="true" focusable="false" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path>
                                            </svg>}
                                    </button> : <button
                                        data-tooltip-content="Answer using the microphone"
                                        data-tooltip-id="record_audio_hover"
                                        disabled={!isTypingDone}
                                        onClick={() => dispatch(updateIsVoiceInput(true))}
                                        style={{ width: "55px", height: "50px", borderRadius: "10rem", cursor: "pointer", backgroundColor: "#4299e1", color: "white" }}
                                    >
                                        <i className="fa fa-microphone"></i>
                                    </button>}
                                </div>
                            }
                        </div>
                    </div>}
                    <ReactTooltip id="record_audio_hover" place="top" effect="solid" interactive={true}
                        style={{ fontSize: "12px" }}> </ReactTooltip>
                </> : <div style={{ display: "flex", justifyContent: "center" }}><img alt="loader" src={require(`../../assets/Images/dot_loading.gif`)} /></div>}
        </div>
    );
}

export default CheckboxGroup;
